<div class="messages-container">
  <div class="gt-page-header">
    <h3><i class="fa fa-envelope"></i> {{ title }}</h3>
  </div>

  <div class="gt-page-body">
    <div class="left-panel">
      <div class="filters">
        <input class="form-control" type="text" placeholder="Search Messages" [ngModel]="searchText" (ngModelChange)="searchText=$event; onSearch()">
        <select class="form-control" [ngModel]="messageType" (ngModelChange)="messageType=$event; onFilterChange()">
          <option value="1">Show All</option>
          <option value="4">Sent</option>
          <option value="2">Read</option>
          <option value="3">New</option>
          <option value="5">Archive</option>
          <option value="6">Resolved</option>
          <option value="7">Follow Up</option>
        </select>
      </div>

      @if (!showFormLoader) {
<div class="msg-list">
        @for (comment of filteredComments; track $index) {
<div class="msg-item" (click)="selectComment(comment)">
          <div class="msg-name"><strong>{{ comment.display_name || 'User' }}</strong></div>
          <div class="msg-text">{{ comment.message }}</div>
        </div>
}
        @if (filteredComments.length===0) {
<div class="no-data">No messages</div>
}
      </div>
}
      @if (showFormLoader) {
<div class="formLoader"><i class="fa fa-spinner fa-spin gt-refresh"></i></div>
}
    </div>

    <div class="message-body">
      @if (selectedComment) {
<div>
        <div class="subject"><strong>Sub:</strong> {{ selectedComment.subject || '-' }}</div>
        <div class="content">{{ selectedComment.message }}</div>
        <div class="reply-box">
          <textarea class="form-control" placeholder="add a reply message" (keyup)="commentReply($event)"></textarea>
        </div>
      </div>
} @else {

        <div class="no-data">Select a message to read it.</div>
      
}
      
    </div>

    <div class="contact-info" [class.open]="contactOpen">
      <div class="contact-header">
        Contact Details
        <i class="fa fa-times" (click)="contactOpen=false"></i>
      </div>
      @if (selectedComment) {
<div class="contact-body">
        <div>Name: {{ selectedComment.display_name || '-' }}</div>
        <div>SSO Id: {{ selectedComment.sso_id || '-' }}</div>
      </div>
}
    </div>
  </div>

  <div class="actions">
    <button type="button" class="save-button" (click)="onRefresh()">Refresh</button>
    <button type="button" class="cancel-button" (click)="onCancel()">Close</button>
  </div>
</div>
